import { FapBaseModel } from '../../base/fap-base-model';


export class PeopleGroupModel extends FapBaseModel {
    public static fields: Array<string> = [
        'id',
        'name',
        'company',
        'users',
    ];

    public static requiredFields: Array<string> = [
        'id',
    ];

    public static extendedFields: {} = {
    };

    public id: number;
    public name: string;
    public company: number;
    public users: number[];
}
